module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0148.jpg?v=bb1464c1";